// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduledMaintenanceReminderTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceReminderTypeApiClient extends BaseCRUDApiClient<ScheduledMaintenanceReminderTypeDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance-reminder-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
